import axios from '@/plugins/axios'
import {reactiveData as response} from "vue-chartjs/es/mixins";

export default {
    namespaced: true,

    state: {
        loading: false,
        links: [],
        page: 1,
        page_size: 10,
        order_column: 'created_at',
        order_type: 'desc',
        dialog: false,
        channel: {
            channel_id: null,
            id: null,
            manager_user_id: null,
        },
        channel_info: {},
        channel_id_valid: null,
        mcn_managers: [],
        filter: 'all',
    },

    mutations: {
        setLinks(state, payload) {
            state.links = payload
        },
        setPage(state, payload) {
            state.page = payload
        },
        setPageSize(state, payload) {
            state.page_size = payload
        },
        setOrdering(state, payload) {
            state.order_column = payload.column
            state.order_type = payload.type || "desc";
        },
        setLoading(state, payload) {
            state.loading = payload
        },
        setDialog(state, payload) {
            state.dialog = payload
        },
        setMcnManager(state, payload) {
            state.mcn_managers = payload
        },
        setChannelInfo(state, payload) {
            state.channel_info = payload
        },
        setChannelIdValid(state, payload) {
            state.channel_id_valid = payload
        },
        setFilter(state, payload) {
            state.filter = payload
        }
    },

    actions: {
        read({ commit, state }, userId = null) {
            commit('setLoading', true)
            axios.admin
                .get('cms/mcn-channels', {
                    params: {
                        page: state.page,
                        page_size: state.page_size,
                        order_column: state.order_column,
                        order_type: state.order_type,
                        user_id: userId,
                        filter: state.filter
                    }
                })
                .then(r => {
                    commit('setLinks', r.data.data)
                    commit('setLoading', false)
                })
                .catch(() => {
                    commit('setLoading', false)
                })
        },
        delete({ dispatch }, id) {
            axios.admin.delete('cms/mcn-channels/remove/' + id).then(() => {
                dispatch('read')
            })
        },
        insert({ commit, dispatch, state }) {
            axios.admin
                .post('cms/mcn-channels', {
                    channel_id: state.channel.channel_id,
                    manager_user_id: state.channel.manager_user_id,
                    report_type: state.channel.report_type
                })
                .then(() => {
                    commit('setDialog', false)
                    commit('setChannelInfo', {}) // Reset channel_info
                    commit('setChannelIdValid', null)
                    dispatch('read')
                })
        },
        readMcnManagers({ state, commit }) {
            commit('setLoading', true)
            axios.admin
                .get('cms/mcn-channels/mcn-managers')
                .then(r => {
                    commit('setMcnManager', r.data.data)
                    commit('setLoading', false)
                })
                .catch(() => {
                    commit('setLoading', false)
                })
        },
        checkChannel({ commit, dispatch, state }) {
            axios.admin
                .post('cms/mcn-channels/check-channel', {
                    channel_id: state.channel.channel_id
                })
                .then(response => {
                    commit('setChannelInfo', response.data.data)
                    commit('setChannelIdValid', true)
                })
                .catch(() => {
                    commit('setChannelInfo', {})
                    commit('setChannelIdValid', false)
                })
        },
    },

    getters: {}
}
